module.exports = __webpack_public_path__ + "static/media/11_tearsofhair.8f7b619a.jpg";